// extracted by mini-css-extract-plugin
export default {"additional-swatch-selector":"configurator-web-additional-swatch-selector","show-menu-button":"configurator-web-show-menu-button"};